import React from 'react'
import { Link } from "react-router-dom";
import { logOutRedirectCall } from '../../../pages/Common/RedirectPathMange';

export default function SideBar() {
    return (
        <aside id="leftsidebar" className="sidebar">
            <div className="user-info">
                <div className="info-container">
                    <div className="name" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" role="button">{localStorage.getItem("DAname")}</div>
                    <div className="email">{localStorage.getItem("DAemail")}</div>

                    <div className="btn-group user-helper-dropdown"> 
                    {/* <i className="material-icons" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" role="button"> keyboard_arrow_down </i> */}
                        <ul className="dropdown-menu pull-right">
                            <li><button onClick={() => logOutRedirectCall()}><i className="material-icons">input</i>Sign Out</button></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="menu">
                <ul className="list">
                    <li><Link to="/dashboard"><i className="zmdi zmdi-delicious"></i><span>Dashboard</span> </Link> </li>
                    <li><Link to="/update-profile"><i className="zmdi zmdi-account-circle"></i><span>Update Profile</span></Link></li>
                    <li><Link to="/wallet-controls"><i className="zmdi zmdi-accounts-list"></i><span>Wallet Controls</span></Link></li>
                    {/* <li><Link to="/4for4panel"><i className="zmdi zmdi-account"></i><span>4for4panel</span></Link></li> */}
                    {/* <li><Link to="/manage-promocode"><i className="zmdi zmdi-shopping-basket"></i><span>Promocodes</span></Link></li> */}
                    {/* <li><Link to="/accounting"><i className="zmdi zmdi-calendar"></i><span>Accounting</span></Link></li> */}
                    {/* <li><Link to="/manage-donation"><i className="zmdi zmdi-money"></i><span>Manage Donation</span></Link></li> */}
                    {/* <li><Link to="/reports"><i className="zmdi zmdi-file-text"></i><span>Generate Report</span></Link></li> */}
                    <li><Link to="/changepassword"><i className="zmdi zmdi-keyboard"></i><span>Change Password</span></Link></li>
                    {/* <li><Link to="" onClick={() => logOutRedirectCall()}><i className="zmdi zmdi-power-off"></i><span>Sign Out</span></Link></li> */}
                </ul>
            </div>
        </aside>
    )
}